import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from '../../../services/message.service';
import { SharedService } from '../../../services/shared.service';

@Component({
  standalone: false,
  selector: 'app-material-autocomplete',
  templateUrl: './material-autocomplete.component.html',
  styleUrls: ['./../autocomplete.component.scss']
})
export class MaterialAutocompleteComponent {
  @Input() placeholder: string;
  @Input() searchTerm: string;
  @Input() isProduct: boolean;
  @Input() workRequestId: string;
  items: Array<any> = [];
  input: string;
  isListVisible: boolean;

  @Output() readonly selected: EventEmitter<any> = new EventEmitter<any>();

  constructor(private sharedService: SharedService,
              private message: MessageService) {
  }

  getAllItems(): any {
    this.getAllMaterials();
  }

  getAllMaterials(): void {
    const inputValue = this.isProduct ? this.searchTerm : this.input;
    this.sharedService.getAllMaterials(inputValue, this.workRequestId).subscribe(
      res => {
        this.items = res.results;
        this.isListVisible = this.items.length > 0 && inputValue.length > 0;
      },
      err => {
        this.message.error(err);
      }
    );
  }

  onSelect(item: any): any {
    this.selected.emit(item);
    this.isListVisible = false;

    if (!this.isProduct) {
      this.input = item.name;
    } else {
      this.searchTerm = item.name;
    }
  }

  trackByFn(index: number): number {
    return index;
  }
}
